import React, { useEffect } from "react";
import MainHeaderSection from "../components/Home/MainHeaderSection";
import BrandsCarousel from "../components/Home/BrandsCarousel";
import PromoWeb from "../components/Home/PromoWeb";
import PartsBenefits from "../components/Home/PartsBenefits";
import PromoCMSoltec from "../components/Home/PromoCMSoltec";
import ProfessionalTraining from "../components/Home/ProfessionalTraining";
import WhyChoose from "../components/Home/WhyChoose";
import Partners from "../components/Home/Partners";

import banner from "../static/media/home/banner.webp";

import "./HomePage.css";

function HomePage() {
  useEffect(() => {
    document.title = "CMSOLTEC | Venta y Mantenimiento de Computadoras";
    window.scrollTo(0, 0);
  }, []);

  return (
    <main>
      <MainHeaderSection />
      <BrandsCarousel />

      <div className="homepage-banner-container">
        <img src={banner} alt="Banner CMSOLTEC" className="homepage-banner-img" />
        <div className="homepage-banner-content">
          <a href="/categorias" className="homepage-btn-banner">
            Ver Tienda
          </a>
        </div>
      </div>

      <PromoWeb />
      <PartsBenefits />
      <PromoCMSoltec />
      <ProfessionalTraining />
      <WhyChoose />
      <Partners />
    </main>
  );
}

export default HomePage;
